<template>
  <div>


    <div class="row">
      <div class="col-12 col-xl-10 m-auto">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-8 col-lg-10">
                <h4 class="title">Analysis on <span v-if="task">{{ task.search_company }}</span><span v-else>-</span></h4>
                <p class="description">Creation date: <span v-if="task">{{ formatDate(task.request_date, true) }}</span></p>
              </div>
              <div class="col-4 col-lg-2">
<!--                <n-button native-type="button" type="outline-primary" class="d-block mt-5"-->
<!--                          :disabled="loading || saving">-->
<!--                  Export data-->
<!--                </n-button>-->
              </div>
            </div>

          </div>
          <div class="card-body">

            <div class="row" v-if="loading">
              <div class="col-12 text-center font-weight-bold">
                <span class="text-danger d-block"><i class="fa fa-spinner fa-spin"></i> {{ $t('common.loading') }}...</span>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12 col-md-6 text-center">
                <div class=" m-2 border">
                  <p class="mt-1 mb-0">Period of analysis</p>
                  <hr class="m-1"/>
                  <h5 style="font-size: 20px" class="mb-1">
                    <span v-if="task">
                      {{ formatDate(task.analysis_start_date.date, false) }} - {{ formatDate(task.analysis_end_date.date, false) }}</span>
                    <span v-else>-</span>
                  </h5>
                </div>
              </div>



              <div class="col-12 col-md-6 text-center">
                <div class=" m-2 border">
                  <p class="mt-1 mb-0">Max news to analyze</p>
                  <hr class="m-1"/>
                  <h5 style="font-size: 20px" class="mb-1">
                    <span v-if="task">{{ task.max_insights }}</span>
                    <span v-else>-</span>
                  </h5>
                </div>
              </div>



              <div class="col-12 col-md-6 text-center">
                <div class=" m-2 border">
                  <p class="mt-1 mb-0">Company</p>
                  <hr class="m-1"/>
                  <h5 style="font-size: 20px" class="mb-1">
                    <span v-if="task">
                      {{ task.search_company }}
                      <n-button native-type="button" type="outline-primary" class="px-1 btn-icon btn-sm m-0"
                                v-on:click="showCompaniesBox" style="font-size: 12px;">
                        <font-awesome-icon icon="info"></font-awesome-icon>
                      </n-button>
                    </span>
                    <span v-else>-</span>
                  </h5>
                </div>
              </div>



              <div class="col-12 col-md-6 text-center">
                <div class=" m-2 border">
                  <p class="mt-1 mb-0">Selected Countries</p>
                  <hr class="m-1"/>
                  <h5 style="font-size: 20px" class="mb-1">
                    <span v-if="task">
                      <span v-if="task.countries && task.countries.length > 0">
                        <span v-for="(c, i) in task.countries" v-bind:key="c">{{ c }}<span v-if="i<task.countries.length -1">, </span></span>
                      </span>
                      <span v-else>All</span>
                    </span>
                    <span v-else>-</span>
                  </h5>
                </div>
              </div>


              <div class="col-12 text-center">
                <div class=" m-2 border">
                  <p class="mt-1 mb-0">Selected industries</p>
                  <hr class="m-1"/>
                  <h5 style="font-size: 20px" class="mb-1">
                    <span v-if="task">
                      <span v-if="task.industries && task.industries.length > 0">
                        <span v-for="(c, i) in task.industries" v-bind:key="c">{{ c }}<span v-if="i<task.industries.length -1">, </span></span>
                      </span>
                      <span v-else>None</span>
                    </span>
                    <span v-else>-</span>
                  </h5>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>





    <div class="row">
      <div class="col-12 col-xl-10 m-auto">
        <div class="card">
          <div class="card-header">
          </div>
          <div class="card-body">

            <div class="row">
              <div class="col-12 mt-4">
                <p class="text-center">Total news analyzed:
                  <span v-if="statistics" class="font-weight-bold">{{ statistics["tot_insights"] }} ({{ (statistics["own_insights"]/statistics["tot_insights"]*100).toFixed(0) }}% own news)</span>
                  <span v-else>-</span>
                </p>

                <el-table class="table-striped" :data="analysis" border style="width: 100%">
<!--                          :header-cell-style="{'font-size': '14px', 'font-weight': 'bold'}"-->


                  <el-table-column type="expand">
                    <template #default="props">
                      <div class="row">
                        <div class="col-12">
                          <p>Justification of the assigned score:</p>
                          <p class="text-justify"
                             v-if="!analysis[props.$index].justification || analysis[props.$index].justification == null || analysis[props.$index].justification.length === 0">
                            There are no news talking about this aspect.</p>
                          <p v-else class="text-justify">{{ analysis[props.$index].justification }}</p>
                        </div>


                        <div class="col-12 py-2" style="max-height: 400px; overflow-y:auto; border: 1px solid lightgray; border-radius: 8px;">
                            <el-tree :props="{isLeaf: 'isLeaf'}"
                                     :load="analysis[props.$index].irg_parameter == 1 ? load_sources_1 :
                                            analysis[props.$index].irg_parameter == 2 ? load_sources_2 :
                                            analysis[props.$index].irg_parameter == 3 ? load_sources_3 :
                                            analysis[props.$index].irg_parameter == 4 ? load_sources_4 :
                                            analysis[props.$index].irg_parameter == 5 ? load_sources_5 :
                                            analysis[props.$index].irg_parameter == 6 ? load_sources_6 :
                                            analysis[props.$index].irg_parameter == 7 ? load_sources_7 :
                                            analysis[props.$index].irg_parameter == 8 ? load_sources_8 :
                                            analysis[props.$index].irg_parameter == 9 ? load_sources_9 : load_sources_10"
                                     node-key="id"
                                     :ref="'tree_ref_' + analysis[props.$index].irg_parameter"
                                     lazy>
                              <template #default="{ node, data }">
                                <span class="custom-tree-node">
                                  <span v-if="data.url">
                                    <a :href="data.url" target="_blank"> {{ node.label }} </a>
                                  </span>
                                  <span v-else>{{ node.label }}</span>
                                </span>
                              </template>
                            </el-tree>
                        </div>


                        <div class="col-12 py-2 mt-2" style="max-height: 400px; overflow-y:auto; border: 1px solid lightgray; border-radius: 8px;">
                          <el-tree :props="{isLeaf: 'isLeaf'}"
                                   :load="analysis[props.$index].irg_parameter == 1 ? load_sources_by_score_1 :
                                            analysis[props.$index].irg_parameter == 2 ? load_sources_by_score_2 :
                                            analysis[props.$index].irg_parameter == 3 ? load_sources_by_score_3 :
                                            analysis[props.$index].irg_parameter == 4 ? load_sources_by_score_4 :
                                            analysis[props.$index].irg_parameter == 5 ? load_sources_by_score_5 :
                                            analysis[props.$index].irg_parameter == 6 ? load_sources_by_score_6 :
                                            analysis[props.$index].irg_parameter == 7 ? load_sources_by_score_7 :
                                            analysis[props.$index].irg_parameter == 8 ? load_sources_by_score_8 :
                                            analysis[props.$index].irg_parameter == 9 ? load_sources_by_score_9 : load_sources_by_score_10"
                                   node-key="id"
                                   :ref="'ref_tree_score_' + analysis[props.$index].irg_parameter"
                                   lazy>
                            <template #default="{ node, data }">
                                <span class="custom-tree-node">
                                  <span v-if="data.url">
                                    <a :href="data.url" target="_blank"> {{ node.label }} </a>
                                  </span>
                                  <span v-else-if="data.interval">
                                    <span v-for="star in data.interval">
                                      <font-awesome-icon icon="star" class="text-warning"></font-awesome-icon>
                                    </span>
                                    ({{ data.count }})
                                  </span>
                                  <span v-else>{{node.label}}</span>
                                </span>
                            </template>
                          </el-tree>
                        </div>



                        <div class="col-12 py-2 mt-2" style="max-height: 400px; overflow-y:auto; border: 1px solid lightgray; border-radius: 8px;">
                          <div class="row">
                            <div class="col-12">
                              <p class="pl-2 d-block mb-0">Filter sources by name:</p>
                            </div>

<!--                          TODO: this is a bad solution for different variables in v-model based on the irg param. Find a better solution -->
                            <div class="col-12 col-md-6 col-xl-4">

                              <el-select
                                  v-if="analysis[props.$index].irg_parameter == 1"
                                  v-model="selectSourcesToSearch[1]"
                                  data
                                  multiple
                                  filterable
                                  placeholder="type to search..."
                                  clearable
                                  class="d-block"
                                  style="font-size: 18px">
                                <el-option
                                    v-for="item in listSources[analysis[props.$index].irg_parameter]"
                                    :key="item.source_contify_id"
                                    :label="item.source_name"
                                    :value="item.source_contify_id"/>
                              </el-select>

                              <el-select
                                  v-else-if="analysis[props.$index].irg_parameter == 2"
                                  v-model="selectSourcesToSearch[2]"
                                  data
                                  multiple
                                  filterable
                                  placeholder="type to search..."
                                  clearable
                                  class="d-block"
                                  style="font-size: 18px">
                                <el-option
                                    v-for="item in listSources[analysis[props.$index].irg_parameter]"
                                    :key="item.source_contify_id"
                                    :label="item.source_name"
                                    :value="item.source_contify_id"/>
                              </el-select>

                              <el-select
                                  v-else-if="analysis[props.$index].irg_parameter == 3"
                                  v-model="selectSourcesToSearch[3]"
                                  data
                                  multiple
                                  filterable
                                  placeholder="type to search..."
                                  clearable
                                  class="d-block"
                                  style="font-size: 18px">
                                <el-option
                                    v-for="item in listSources[analysis[props.$index].irg_parameter]"
                                    :key="item.source_contify_id"
                                    :label="item.source_name"
                                    :value="item.source_contify_id"/>
                              </el-select>

                              <el-select
                                  v-else-if="analysis[props.$index].irg_parameter == 4"
                                  v-model="selectSourcesToSearch[4]"
                                  data
                                  multiple
                                  filterable
                                  placeholder="type to search..."
                                  clearable
                                  class="d-block"
                                  style="font-size: 18px">
                                <el-option
                                    v-for="item in listSources[analysis[props.$index].irg_parameter]"
                                    :key="item.source_contify_id"
                                    :label="item.source_name"
                                    :value="item.source_contify_id"/>
                              </el-select>

                              <el-select
                                  v-else-if="analysis[props.$index].irg_parameter == 5"
                                  v-model="selectSourcesToSearch[5]"
                                  data
                                  multiple
                                  filterable
                                  placeholder="type to search..."
                                  clearable
                                  class="d-block"
                                  style="font-size: 18px">
                                <el-option
                                    v-for="item in listSources[analysis[props.$index].irg_parameter]"
                                    :key="item.source_contify_id"
                                    :label="item.source_name"
                                    :value="item.source_contify_id"/>
                              </el-select>

                              <el-select
                                  v-else-if="analysis[props.$index].irg_parameter == 6"
                                  v-model="selectSourcesToSearch[6]"
                                  data
                                  multiple
                                  filterable
                                  placeholder="type to search..."
                                  clearable
                                  class="d-block"
                                  style="font-size: 18px">
                                <el-option
                                    v-for="item in listSources[analysis[props.$index].irg_parameter]"
                                    :key="item.source_contify_id"
                                    :label="item.source_name"
                                    :value="item.source_contify_id"/>
                              </el-select>

                              <el-select
                                  v-else-if="analysis[props.$index].irg_parameter == 7"
                                  v-model="selectSourcesToSearch[7]"
                                  data
                                  multiple
                                  filterable
                                  placeholder="type to search..."
                                  clearable
                                  class="d-block"
                                  style="font-size: 18px">
                                <el-option
                                    v-for="item in listSources[analysis[props.$index].irg_parameter]"
                                    :key="item.source_contify_id"
                                    :label="item.source_name"
                                    :value="item.source_contify_id"/>
                              </el-select>

                              <el-select
                                  v-else-if="analysis[props.$index].irg_parameter == 8"
                                  v-model="selectSourcesToSearch[8]"
                                  data
                                  multiple
                                  filterable
                                  placeholder="type to search..."
                                  clearable
                                  class="d-block"
                                  style="font-size: 18px">
                                <el-option
                                    v-for="item in listSources[analysis[props.$index].irg_parameter]"
                                    :key="item.source_contify_id"
                                    :label="item.source_name"
                                    :value="item.source_contify_id"/>
                              </el-select>

                              <el-select
                                  v-else-if="analysis[props.$index].irg_parameter == 9"
                                  v-model="selectSourcesToSearch[9]"
                                  data
                                  multiple
                                  filterable
                                  placeholder="type to search..."
                                  clearable
                                  class="d-block"
                                  style="font-size: 18px">
                                <el-option
                                    v-for="item in listSources[analysis[props.$index].irg_parameter]"
                                    :key="item.source_contify_id"
                                    :label="item.source_name"
                                    :value="item.source_contify_id"/>
                              </el-select>

                              <el-select
                                  v-else
                                  v-model="selectSourcesToSearch[10]"
                                  data
                                  multiple
                                  filterable
                                  placeholder="type to search..."
                                  clearable
                                  class="d-block"
                                  style="font-size: 18px">
                                <el-option
                                    v-for="item in listSources[analysis[props.$index].irg_parameter]"
                                    :key="item.source_contify_id"
                                    :label="item.source_name"
                                    :value="item.source_contify_id"/>
                              </el-select>
                            </div>

                            <div class="col-12 col-md-6 col-xl-4">
                              <n-button native-type="button" type="outline-default" class="btn-sm d-block"
                                        style="margin-top: 15px; font-size: 15px"
                                        :disabled="loading || saving || !selectSourcesToSearch[analysis[props.$index].irg_parameter] || selectSourcesToSearch[analysis[props.$index].irg_parameter].length === 0"
                                        v-on:click="filterSources(analysis[props.$index].irg_parameter)">
                                <i class="now-ui-icons ui-1_zoom-bold"></i> Apply filter
                              </n-button>
                            </div>
                            <div class="col-12 mt-3" style="max-height: 400px; overflow-y:auto;">
                              <span v-if="saving" class="text-danger d-block">
                                <i class="fa fa-spinner fa-spin"></i> {{ $t('common.loading') }}...
                              </span>
                              <span v-for="s in filteredSources[analysis[props.$index].irg_parameter]" v-bind:key="s.source_contify_id">
                                <a :href="s.url" target="_blank">
                                  {{ s.source_name }} - Relevance: {{ s.membership }}/100 - Semantic Score: {{ s.sentiment }}
                                </a>
                                <br>
                              </span>
                            </div>
                          </div>

                        </div>

                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column key="name" :min-width="200" prop="name" label="IRG parameter" label-class-name="text-break">
                    <template #default="scope">
                      <span>{{scope.$index+1}}. {{ scope.row.name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column key="num_fragments" :min-width="120" prop="num_fragments" label="# News" align="right">
                    <template #default="scope">
                      <span>{{ scope.row.num_fragments }}</span>
<!--                      <span>{{ scope.row.num_fragments }} ({{ statistics["own_insights_irg"][scope.row.irg_parameter] }})</span>-->
                    </template>
                  </el-table-column>
                  <el-table-column key="sentiment" :min-width="180" prop="sentiment" align="right">
                    <template #header>
                      Semantic Score
                      <n-button native-type="button" type="outline-primary" class="btn-icon btn-sm m-0 my-info-button"
                                v-on:click="showInfoBox('Semantic Score', 'Value in [-100;+100] representing the score of this company computed for a given IRG dimension, considering each news in an equal manner.')">
                        <font-awesome-icon icon="info"></font-awesome-icon>
                      </n-button>
                    </template>
                    <template #default="scope">
                      <span v-if="!scope.row.sentiment || scope.row.sentiment.length === 0">N/A</span>
                      <span v-else>{{ scope.row.sentiment.toFixed(2) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column key="weighted_sentiment" :min-width="200" prop="weighted_sentiment" align="right" label-class-name="text-break">
                    <template #header>
                      Weighted Semantic Score
                      <n-button native-type="button" type="outline-primary" class="px-1 btn-icon btn-sm m-0 my-info-button"
                                v-on:click="showInfoBox('Weighted Semantic Score', 'Value in [-100;+100] representing the score of this company computed for a given IRG dimension, considering each news weighted according to its relevance to the IRG dimension.')">
                        <font-awesome-icon icon="info"></font-awesome-icon>
                      </n-button>
                    </template>
                    <template #default="scope">
                      <span v-if="!scope.row.weighted_sentiment || scope.row.weighted_sentiment.length === 0">N/A</span>
                      <span v-else>{{ scope.row.weighted_sentiment.toFixed(2) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column key="score" prop="score" :min-width="160" align="right" label-class-name="text-break">
                    <template #header>
                      IRG Score
                      <n-button native-type="button" type="outline-primary" class="px-1 btn-icon btn-sm m-0 my-info-button"
                                v-on:click="showInfoBox('IRG Score', 'Final IRG score in [0;3] for a given IRG dimension computed on the basis of the Weighted Semantic Score.')">
                        <font-awesome-icon icon="info"></font-awesome-icon>
                      </n-button>
                    </template>
                    <template #default="scope">
                      <span v-if="scope.row.num_fragments <=10">
                        <n-button native-type="button" type="outline-default" class="px-1 btn-icon btn-sm mx-2 my-alert-button align-baseline"
                                  v-on:click="showInfoBox('Warning', 'The score was computed on a very limited set of news')">
                        <font-awesome-icon icon="exclamation-triangle" style="color: #FFB236"></font-awesome-icon>
                      </n-button>
                      </span>
                      <span v-if="!scope.row.score">N/A</span>
                      <span v-else class="font-weight-bold" style="font-size: large"
                          :class="scope.row.score <1.05 ? 'text-danger' : scope.row.score < 2.94 ? 'text-warning' : 'text-success'">
                        {{ scope.row.score.toFixed(1) }}
                      </span>
                    </template>
                  </el-table-column>

                  <template #empty="">
                    <span>{{ $t('common.no_data') }}</span>
                  </template>

                </el-table>
              </div>

              <div class="col-12 text-center mt-5">
                <div class="row">
                  <div class="col-12 col-md-8 col-lg-5 col-xl-4 m-auto border border-primary">
                    <h5 class="mb-0">Final IRG Score: <span v-if="report">{{ report.irg_score }}</span><span v-else>{{ finalScore }}</span></h5>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>





    <div class="row">
      <div class="col-12 col-xl-10 m-auto">
        <div class="card">
          <div class="card-header">
          </div>
          <div class="card-body">

            <div class="row">
              <div class="col-12 mb-3">
                <n-button native-type="button" type="outline-default" class="btn-sm d-block"
                          style="margin-top: 15px; font-size: 15px"
                          :disabled="loading || saving"
                          v-on:click="searchByPreferredSources()">
                  <i class="now-ui-icons ui-1_zoom-bold"></i> Filter News from Business News Agencies
                </n-button>
              </div>


              <div class="col-12">
                <p class="pl-2 d-block mb-0">Filter news by source name:</p>
              </div>

              <div class="col-12 col-md-6 col-xl-4">

                <el-select
                    v-model="selectSourcesToSearch[0]"
                    data
                    multiple
                    filterable
                    placeholder="type to search..."
                    clearable
                    class="d-block"
                    style="font-size: 18px">
                  <el-option
                      v-for="item in listSources[0]"
                      :key="item.source_contify_id"
                      :label="item.source_name"
                      :value="item.source_contify_id"/>
                </el-select>
              </div>

              <div class="col-12 col-md-6 col-xl-3">
                <n-button native-type="button" type="outline-default" class="btn-sm d-block"
                          style="margin-top: 15px; font-size: 15px"
                          :disabled="loading || saving || selectSourcesToSearch[0].length === 0"
                          v-on:click="filterSources(0)">
                  <i class="now-ui-icons ui-1_zoom-bold"></i> Apply filter
                </n-button>
              </div>



              <div class="col-12 mt-3" style="max-height: 400px; overflow-y:auto;">
                <span v-if="saving" class="text-danger d-block">
                  <i class="fa fa-spinner fa-spin"></i> {{ $t('common.loading') }}...
                </span>
                <span v-if="filteredSources[0] && filteredSources[0].length > 0" class="d-block">{{filteredSources[0].length}} news found:</span>
                <span v-for="s in filteredSources[0]" v-bind:key="s.source_contify_id">
                  <a :href="s.url" target="_blank">
                    {{ s.source_name }}: "{{ s.title.substring(0,100) }}<span v-if="s.title.length > 100">...</span>"
                  </a>
                  <br>
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>





    <div class="row" v-if="report && report.justifications_summary">
      <div class="col-12 col-xl-10 m-auto">
        <div class="card">

          <div class="card-header">
            <h4 class="title">Summary</h4>
          </div>
          <div class="card-body">

            <div class="row">
              <div class="col-12">
                <p class="text-justify" style="white-space: pre-line;"> {{ report.justifications_summary }} </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>



  </div>
</template>

<script>
  import axios from 'axios';
  import { ElMessage, ElDatePicker, ElInput, ElSelect, ElOption, ElTable, ElTableColumn, ElTree } from "element-plus";
  import Swal from "sweetalert2";

  export default {
    name: "ShowTask",
    components: {
        [ElDatePicker.name]: ElDatePicker,
        [ElInput.name]: ElInput,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
        [ElTable.name]: ElTable,
        [ElTableColumn.name]: ElTableColumn,
        [ElTree.name]: ElTree,
    },
    data () {
      return {
        loading: true,
        saving: false,
        error: null,
        task: null,
        analysis: null,
        statistics: null,
        report: null,
        filterTree: null,
        sourcesCountries: [],
        sourcesChannels: [],
        sourcesTopics: [],
        sourcesUrls: [],
        sourcesIntervals: [],
        sourcesScores: [],
        // index = 0 searches in all sources, regardless the irg param
        listSources: [],
        filteredSources: [],
        selectSourcesToSearch: [],
      }
    },
    methods: {
      showError(error) {
        this.error = "";
        if (error.response && error.response.status === 401 && error.config && !error.config.__isRetryRequest) {
            this.error = this.$i18n.t("error.login_expired");
            this.$store.commit('logout');
            this.$router.push('/login');
        }
        else if (error.response && error.response.data && error.response.data.violations &&
            error.response.data.violations.length > 0) {
            for (let i = 0; i < error.response.data.violations.length; i++)
            {
                let stringErr = error.response.data.violations[i].message;
                if(stringErr.endsWith("."))
                    stringErr = stringErr.slice(0, -1);
                this.error += this.$i18n.t(stringErr) + ". ";
            }
        } else if(error.response && error.response.data && error.response.data.message)
        {
            let stringErr = error.response.data.message;
            if(stringErr.endsWith("."))
                stringErr = stringErr.slice(0, -1);
            this.error = this.$i18n.t("error." + stringErr);
        }
        else if (error.response && error.response.data && error.response.data['hydra:description'])
            this.error = this.$i18n.t("error." + error.response.data['hydra:description']);
        else this.error = this.$i18n.t("error.try_again");
        ElMessage.error(this.error);
        console.log(error);
      },
      formatDate(date, time = true) {
        var dateObj = new Date(date);
        if(time)
            return dateObj.toLocaleString();
        else
            return dateObj.toLocaleDateString();
      },
      disabledDate(time) {
        return time.getTime() > (new Date());
      },
      showCompaniesBox() {
        let text = "<p>List of companies included in this analysis: </p>";
        for (let c of this.task.companies) {
          text += "<p>" + c.name + " <span class='text-black-50'>(" + c.url + ")</span></p>";
        }

        Swal.fire({
          position: 'top-end',
          title: "Companies",
          html: text,
          showConfirmButton: false,
          showCloseButton: true
        });
      },
      showInfoBox(title, text) {
        Swal.fire({
          position: 'top-end',
          title: title,
          text: text,
          showConfirmButton: false,
          showCloseButton: true,
          customClass: {
            title: 'font-size-18',
          }
        });
      },
      load_sources_1 (node, resolve, reject) {
        return this.loadSources(1, node, resolve, reject);
      },
      load_sources_2 (node, resolve, reject) {
        return this.loadSources(2, node, resolve, reject);
      },
      load_sources_3 (node, resolve, reject) {
        return this.loadSources(3, node, resolve, reject);
      },
      load_sources_4 (node, resolve, reject) {
        return this.loadSources(4, node, resolve, reject);
      },
      load_sources_5 (node, resolve, reject) {
        return this.loadSources(5, node, resolve, reject);
      },
      load_sources_6 (node, resolve, reject) {
        return this.loadSources(6, node, resolve, reject);
      },
      load_sources_7 (node, resolve, reject) {
        return this.loadSources(7, node, resolve, reject);
      },
      load_sources_8 (node, resolve, reject) {
        return this.loadSources(8, node, resolve, reject);
      },
      load_sources_9 (node, resolve, reject) {
        return this.loadSources(9, node, resolve, reject);
      },
      load_sources_10 (node, resolve, reject) {
        return this.loadSources(10, node, resolve, reject);
      },
      async loadSources(irg, node, resolve, reject) {
        if (node.level === 0) {
          return resolve([{label: "Browse sources by country and topic", count: "count", id: "source_" + irg}]);
        }
        else if (node.level === 1) {
          // return resolve([{label: "label", country: "country", count: "count", irg: irg}]);
          if (typeof this.sourcesCountries[irg] === 'undefined') {
            await axios.get(process.env.VUE_APP_SERVER_BASE_URL + "get_sources_countries_by_irg/",
                {params: {taskId: this.task.id, irg: irg}} )
            .then(response => {
              this.sourcesCountries[irg] = response.data;
              return resolve(this.sourcesCountries[irg]);
            }).catch(error => {
              this.showError(error);
              return reject;
            });
          }
          else
            return resolve(this.sourcesCountries[irg]);
        }



        else if (node.level === 2) {
          let country = node.data.country;
          // console.log("country: " + country);
          if (typeof this.sourcesChannels[irg] === 'undefined' || typeof this.sourcesChannels[irg][country] === 'undefined') {
            console.log("calling server...")
            await axios.get(process.env.VUE_APP_SERVER_BASE_URL + "get_sources_channel_by_country_irg/",
                {params: {taskId: this.task.id, irg: irg, country: country}})
                .then(response => {
                  this.sourcesChannels[irg] = [];
                  this.sourcesChannels[irg][country] = response.data;
                  return resolve(this.sourcesChannels[irg][country]);
                }).catch(error => {
                  this.showError(error);
                  return reject;
                });
          }
          else
          {
            console.log("already available")
            return resolve(this.sourcesChannels[irg][country]);
          }
        }

      else if (node.level === 3) {
        let country = node.data.country;
        let channel = node.data.channel;
        if (typeof this.sourcesTopics[irg] === 'undefined' || typeof this.sourcesTopics[irg][country] === 'undefined' || typeof this.sourcesTopics[irg][country][channel] === 'undefined') {
          await axios.get(process.env.VUE_APP_SERVER_BASE_URL + "get_sources_topic_by_channel_country_irg/",
              {params: {taskId: this.task.id, irg: irg, country: country, channel: channel}})
              .then(response => {
                this.sourcesTopics[irg] = [];
                this.sourcesTopics[irg][country] = [];
                this.sourcesTopics[irg][country][channel] = response.data;
                return resolve(this.sourcesTopics[irg][country][channel]);
              }).catch(error => {
                this.showError(error);
                return reject;
              });
        }
        else
          return resolve(this.sourcesTopics[irg][country][channel]);
      }

      else if (node.level === 4) {
          let country = node.data.country;
          let channel = node.data.channel;
          let topic = node.data.topic;
          if (typeof this.sourcesUrls[irg] === 'undefined' || typeof this.sourcesUrls[irg][country] === 'undefined' || typeof this.sourcesUrls[irg][country][channel] === 'undefined' || typeof this.sourcesUrls[irg][country][channel][topic] === 'undefined') {
            await axios.get(process.env.VUE_APP_SERVER_BASE_URL + "get_sources_by_country_channel_topic_irg/",
                {params: {taskId: this.task.id, irg: irg, country: country, channel: channel, topic: topic}})
                .then(response => {
                  this.sourcesUrls[irg] = [];
                  this.sourcesUrls[irg][country] = [];
                  this.sourcesUrls[irg][country][channel] = [];
                  this.sourcesUrls[irg][country][channel][topic] = response.data;
                  return resolve(this.sourcesUrls[irg][country][channel][topic]);
                }).catch(error => {
                  this.showError(error);
                  return reject;
                });
          }
          else
            return resolve(this.sourcesUrls[irg][country][channel][topic]);
        }
        else
          return resolve([]);
      },
      load_sources_by_score_1(node, resolve, reject) {
        return this.loadSourcesByScore(1, node, resolve, reject);
      },
      load_sources_by_score_2(node, resolve, reject) {
        return this.loadSourcesByScore(2, node, resolve, reject);
      },
      load_sources_by_score_3(node, resolve, reject) {
        return this.loadSourcesByScore(3, node, resolve, reject);
      },
      load_sources_by_score_4(node, resolve, reject) {
        return this.loadSourcesByScore(4, node, resolve, reject);
      },
      load_sources_by_score_5(node, resolve, reject) {
        return this.loadSourcesByScore(5, node, resolve, reject);
      },
      load_sources_by_score_6(node, resolve, reject) {
        return this.loadSourcesByScore(6, node, resolve, reject);
      },
      load_sources_by_score_7(node, resolve, reject) {
        return this.loadSourcesByScore(7, node, resolve, reject);
      },
      load_sources_by_score_8(node, resolve, reject) {
        return this.loadSourcesByScore(8, node, resolve, reject);
      },
      load_sources_by_score_9(node, resolve, reject) {
        return this.loadSourcesByScore(9, node, resolve, reject);
      },
      load_sources_by_score_10(node, resolve, reject) {
        return this.loadSourcesByScore(10, node, resolve, reject);
      },
      async loadSourcesByScore(irg, node, resolve, reject) {
        if (node.level === 0) {
          return resolve([{label: "Browse sources by score", count: "count", id: "source_score_" + irg}]);
        }
        else if (node.level === 1) {
          if (typeof this.sourcesIntervals[irg] === 'undefined') {
            await axios.get(process.env.VUE_APP_SERVER_BASE_URL + "get_sources_scores_intervals_by_irg/",
                {params: {taskId: this.task.id, irg: irg}} )
                .then(response => {
                  this.sourcesIntervals[irg] = response.data;
                  return resolve(this.sourcesIntervals[irg]);
                }).catch(error => {
                  this.showError(error);
                  return reject;
                });
          }
          else
            return resolve(this.sourcesIntervals[irg]);
        }

        else if (node.level === 2) {
          let interval = node.data.interval;
          if (typeof this.sourcesScores[irg] === 'undefined' || typeof this.sourcesScores[irg][interval] === 'undefined') {
            await axios.get(process.env.VUE_APP_SERVER_BASE_URL + "get_sources_by_score_irg/",
                {params: {taskId: this.task.id, irg: irg, interval: interval}})
                .then(response => {
                  this.sourcesScores[irg] = [];
                  this.sourcesScores[irg][interval] = response.data;
                  return resolve(this.sourcesScores[irg][interval]);
                }).catch(error => {
                  this.showError(error);
                  return reject;
                });
          }
          else
            return resolve(this.sourcesScores[irg][interval]);
        }
        else
          return resolve([]);
      },
      filterSources(irg) {
        this.saving = true;
        this.filteredSources[irg] = [];

        if (this.selectSourcesToSearch[irg].length === 0) {
          Swal.fire({
            icon: 'success',
            title: 'Error',
            text: this.$t("show_task.no_source_selected")
          });
          return;
        }


        let url = "get_filtered_sources_by_data_provider_id_irg/";
        if (irg === 0)
          url = "get_filtered_sources_by_data_provider_id/";
        axios.get(process.env.VUE_APP_SERVER_BASE_URL + url,
        {params: {taskId: this.task.id, irg: irg, sources: this.selectSourcesToSearch[irg]}})
        .then(response => {
          this.filteredSources[irg] = response.data;
        }).catch(error => {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: this.$t(error)
          });
        }).finally(() => {
          this.saving = false;
        });
      },
      searchByPreferredSources () {
        this.saving = true;
        this.filteredSources[0] = [];
        let url = "get_filtered_sources_by_data_provider_id/";
        let sourcesProviderIds = [16644, 19236, 61695, 229, 829784, 1196, 8650, 517, 4384, 353, 680407, 19324, 179370, 3775, 4900, 1178480, 3276, 569978, 9200, 6018, 85989, 43084, 5295, 547242, 1041854, 46285, 578628, 531427, 1461556, 686470, 27882, 535697, 47614, 5482];

        axios.get(process.env.VUE_APP_SERVER_BASE_URL + url,
            {params: {taskId: this.task.id, irg: 0, sources: sourcesProviderIds}})
            .then(response => {
              this.filteredSources[0] = response.data;
            }).catch(error => {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: this.$t(error)
          });
        }).finally(() => {
          this.saving = false;
        });
      }
    },
    computed: {
      finalScore() {
        let sum = 0;
        if (this.analysis) {
          for (let i = 0; i < this.analysis.length; i++)
            if(this.analysis[i].score)
              sum += this.analysis[i].score;
        }
        return sum.toFixed(1);
      },
    },
    beforeMount() {
      let fetchedId = this.$route.params.id;
      if (fetchedId) {
        axios.get(process.env.VUE_APP_SERVER_BASE_URL + "get_task_info/" + fetchedId)
            .then(response => {
              this.task = response.data["task"];
              this.analysis = response.data["results"];
              this.statistics = response.data["stats"];
              this.report = response.data["report"];

              for(let i = 0; i<=10; i++) {
                axios.get(process.env.VUE_APP_SERVER_BASE_URL + "get_list_sources_irg/",
                    {params: {taskId: this.task.id, irg: i}})
                    .then(response => {
                      this.listSources[i] = response.data;
                    }).catch(error => {
                  this.showError(error);
                });
              }
        }).catch(error => {
          this.showError(error);
        }).finally(() => {this.loading = false;});


      }
    },
  }
</script>

<style>
  .my-info-button {
    font-size: 10px !important;
    min-width: 1.3rem !important;
    height: 1.3rem !important;
    padding: 0 0 0 1px !important;
    width: 1.3rem !important;
  }

  .my-alert-button {
    font-size: 14px !important;
    min-width: 1.5rem !important;
    height: 1.5rem !important;
    padding: 0 0 0 1px !important;
    width: 1.5rem !important;
  }

  .font-size-18 {
    font-size: 20px !important;
    margin-top: 15px !important;
  }
</style>
